export const CTRL_ENTER = 'ctrl+enter';
export const COMMAND_ENTER = 'command+enter';
export const ESCAPE = 'escape';
export const CTRL_B = 'ctrl+b';
export const COMMAND_B = 'command+b';
export const CTRL_I = 'ctrl+i';
export const COMMAND_I = 'command+i';
export const CTRL_K = 'ctrl+k';
export const COMMAND_K = 'command+k';
export const MOD_K = 'mod+k';
export const CTRL_S = 'ctrl+s';
export const COMMAND_S = 'command+s';
export const ALT_T = 'alt+t';
